import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  constructor() {
  }

  /**
   * Logging function, with 'log' level
   *
   * @param message Message
   * @param args Any additional arguments to log
   */
  public log(message: string, ...args: any[]): void {
    this.logWithLevel('log', message, args);
  }

  /**
   * Logging function, with 'info' level
   *
   * @param message Message
   * @param args Any additional arguments to log
   */
  public info(message: string, ...args: any[]): void {
    this.logWithLevel('info', message, args);
  }

  /**
   * Logging function, with 'warn' level
   *
   * @param message Message
   * @param args Any additional arguments to log
   */
  public warn(message: string, ...args: any[]): void {
    this.logWithLevel('warn', message, args);
  }

  /**
   * Logging function, with 'error' level, gets saved as an AppEvent error
   *
   * @param message Message
   * @param args Any additional arguments to log
   */
  public error(message: string, ...args: any[]): void {
    this.logWithLevel('error', message, args);
  }

  private logWithLevel(logLevel: 'log' | 'info' | 'warn' | 'error', message: string, args: any[]): void {
    let stringMessage = `${message}`;
    args.forEach(arg => {
      if (typeof arg === 'string') {
        stringMessage += `\n${arg}`;
      } else if (typeof arg === 'object') {
        stringMessage += `\n${JSON.stringify(arg, undefined, 2)}`;
      } else {
        stringMessage += `\n${JSON.stringify(arg)}`;
      }
    });
    console[ logLevel ].apply(this, [stringMessage]);
  }

}
